$(function () {
    // Stop all GIF from animating by default
    // Adds a Play/Pause button on GIF
  var gifElements = document.querySelectorAll(
    "#shopify-section-article-amsale img"
  );  

  for (var e in gifElements) {
    var element = gifElements[e];
    let found = false;
    const image_src = element.currentSrc;

    if (image_src != undefined) {
        found = image_src.includes(".gif");
    }

    if (element.nodeName == "IMG" && found) {
      element.classList.add("gif");

      var supergif = new SuperGif({
        gif: element,
        progressbar_height: 0,
        auto_play: false,
      });

      var controlElement = document.createElement("div");
      controlElement.className = "gifcontrol loading g" + e;

      supergif.load(
        function (controlElement) {
          controlElement.className = "gifcontrol paused";
          var playing = false;
          controlElement.addEventListener(
            "click",
            function () {
              if (playing) {
                this.pause();
                playing = false;
                controlElement.className = "gifcontrol paused";
              } else {
                this.play();
                playing = true;
                controlElement.className = "gifcontrol playing";
              }
            }.bind(this, controlElement)
          );
        }.bind(supergif)(controlElement)
      );

      var canvas = supergif.get_canvas();      
      var containerElement = canvas.parentNode;
      containerElement.appendChild(controlElement);
    }
  }
});
